import BTranslator from 'bazinga-translator';
const dictionaryScript = document.getElementById('json_dictionary');
const dictionary = dictionaryScript?.textContent ? JSON.parse(dictionaryScript.textContent) : [];
const Translator = class {
    static init = () => {
        dictionary.forEach(({ key, value, domain, locale }) => {
            BTranslator.add(key, value, domain, locale);
        });
        return BTranslator;
    };
};
export default Translator.init();
